import { useEffect, useState } from "react";

/**
 * Custom hook that debounces a value
 * @param initialValue - The initial value to debounce
 * @param delay - The delay in milliseconds (default: 500ms)
 * @returns A tuple of [debouncedValue, setValue, immediateValue]
 */
export const useDebounce = <T,>(
  initialValue: T,
  delay: number = 500,
): [T, React.Dispatch<React.SetStateAction<T>>, T] => {
  const [value, setValue] = useState<T>(initialValue);
  const [debouncedValue, setDebouncedValue] = useState<T>(initialValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return [debouncedValue, setValue, value];
};
